import { Text } from '@/components/primitives';
import { Icons, vars } from '@/theme';
import { testIds } from '@/test/testIds';
import { ContextSwitcherList } from '../ContextSwitcherList';

/**
 * ContextRequired — the full-page context chooser shown INSTEAD of a
 * context-scoped page when an authenticated user has no org/network context.
 *
 * Why a page and not only {@link ForcedContextSelectionModal}: the modal opens
 * only for `canSwitchContext` users. A context-less user without that flag got
 * the context-scoped page itself — which renders nothing useful and fires a
 * burst of 400 "No organization or network context selected" (vingreact#64:
 * prod user 38851 landed here from SSO and made no further request). The page
 * is the floor: everyone with no context sees something actionable.
 *
 * The body is the SAME searchable {@link ContextSwitcherList} used by the modal
 * and the user-menu dialog, so picking a context is one click and its own empty
 * state ("No contexts available") covers a user who belongs to nothing yet.
 */
export function ContextRequired() {
  return (
    <div
      data-testid={testIds.contextRequired.page}
      style={{
        maxWidth: 560, margin: '0 auto', padding: '48px 24px',
        // The page is capped like a dialog: the list scrolls, the lines under it stay in view.
        display: 'flex', flexDirection: 'column', maxHeight: '100vh', boxSizing: 'border-box',
      }}
    >
      <div style={{ textAlign: 'center', marginBottom: 20, flexShrink: 0 }}>
        <Icons.switchContext
          style={{ fontSize: 48, color: vars.color.success.base, marginBottom: 8 }}
        />
        <Text
          variant="pageHeader"
          data-testid={testIds.contextRequired.title}
          style={{ fontWeight: 600, display: 'block' }}
        >
          Select Organization/Network
        </Text>
        <Text
          color="secondary"
          data-testid={testIds.contextRequired.description}
          style={{ marginTop: 8 }}
        >
          Choose where you want to work to continue. If nothing is listed, ask your
          administrator to add you to an organization.
        </Text>
      </div>

      <ContextSwitcherList />
    </div>
  );
}
